// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"40066869","667":"8082beb4","754":"27821b54","977":"dbd2a82e"}[chunkId] + ".chunk.js";
};